import { formatDistanceToNow } from 'date-fns';
import React, { useEffect, useState } from 'react';

import EmptyBlock from '@components/common/EmptyBlock/EmptyBlock';
import Loader from '@components/common/Loader/Loader';
import Select from '@components/uikit/Select/Select';

import useTranslation from '@hooks/useTranslation';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import { useAssetsTemperatureQuery } from '../../services/useAssetsTemperatureQuery';
import {
  selectRefreshInterval,
  useSensorsTemperatureStoreActions,
} from '../../store/useSensorsTemperatureStore';
import SensorsEquipmentsArea from '../SensorsEquipmentsArea/SensorsEquipmentsArea';
import style from './style.module.scss';

const SensorsEquipment = () => {
  const { t } = useTranslation();
  const { setRefreshInterval } = useSensorsTemperatureStoreActions();

  const [_, setNow] = useState(Date.now());

  const locationSelectValue = selectAppLocationSelectValue();
  const refreshInterval = selectRefreshInterval();

  const {
    data: locationsAssetsData,
    isFetching,
    dataUpdatedAt,
  } = useAssetsTemperatureQuery({
    locationIds:
      locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue?.filterIds,
    refreshInterval: refreshInterval.value,
  });

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const intervalOptions = [
    { label: t('5 min'), value: 5 * 60 * 1000 },
    { label: t('15 min'), value: 15 * 60 * 1000 },
    { label: t('30 min'), value: 30 * 60 * 1000 },
    { label: t('1 hour'), value: 60 * 60 * 1000 },
  ];

  return (
    <div>
      <div className={style.sensorsEquipmentHeaderContainer}>
        <div className={style.filterFieldContainer}>
          <Select
            label={t('Auto refresh interval ')}
            value={refreshInterval}
            onChange={setRefreshInterval}
            options={intervalOptions}
            type="woHelperText"
            itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
          />
        </div>
        {!isFetching && (
          <span className={style.lastFetchedText}>{`Last fetched ${formatDistanceToNow(dataUpdatedAt, {
            addSuffix: true,
          })}`}</span>
        )}
      </div>
      {isFetching && <Loader />}
      {!isFetching && (!locationsAssetsData || locationsAssetsData.length === 0) && (
        <EmptyBlock text={t('Nothing was found.')} />
      )}
      {!isFetching && locationsAssetsData && locationsAssetsData?.length > 0 && (
        <SensorsEquipmentsArea locationsAssetsData={locationsAssetsData} />
      )}
    </div>
  );
};

export default SensorsEquipment;
